/**
Author - Babajan Patan
Git - https://github.com/babajanpatan
* */

import React from "react";
import PropTypes from "prop-types";

import Checkbox from "./Checkbox";

const propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

const CheckboxContainer = ({checked, disabled, onChange, label}) => {
  return (
    <Checkbox
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      label={label}
    />
  );
};

CheckboxContainer.propTypes = propTypes;

export default CheckboxContainer;
